
import TaliServices from "../components/Services/Services"
import styles from "./FifthScreen.module.css"
import ThirdScreen from "./ThirdScreen"

const FifthScreen = () => {
  return <>
       <div className={styles.title}>ועם הזמן למדתי </div>
       <div className={styles.description}>שכל בית, כל אדם וכל משפחה הם ייחודיים ולכל אחד חלומות וצרכים אישיים שונים. מתוך ההבנה הזו, יצרתי מגוון מסלולי ליווי גמישים ומותאמים אישית, המתאימים לכל תקציב, כדי שכל לקוח יוכל למצוא את הפתרון המושלם עבורו. 

 
בין אם מדובר בליווי מלא או בייעוץ ממוקד, אני כאן כדי ללוות אתכם לאורך כל הדרך. יחד, נהפוך את החזון שלכם למציאות וניצור חלל מעוצב ונעים בדיוק כפי שדמיינתם, שישרת אתכם לאורך זמן</div>

<TaliServices/>

          <div className={styles.title}>אז טלי.. איך מעצבת פנים מקצועית משפיעה על התהליך</div>
     
      <ThirdScreen/>

</>
}

export default FifthScreen